/* eslint-disable prettier/prettier */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */

import React from 'react';
import { Helmet } from 'react-helmet';
import { Content } from './styledComponents';

const TerminosYCondiciones = () => {
  return (
    <Content>
      <Helmet>
        <title>Terminos y Condiciones</title>
      </Helmet>
      <h2>Terminos y Condiciones</h2>
      <p>
        “CORPORATIVO 150”, S.A.P.I. DE C.V. (“Responsable” o “Prestavale”), pone
        a disposición de los Usuarios los presentes Términos y Condiciones que
        regirán las relaciones jurídicas que involucren a éstos y a
        "Prestavale", respecto al uso de la Plataforma y de los Servicios, por
        lo que, antes de contratar con "Prestavale" o acceder a su Plataforma,
        necesario que lea estos Términos y Condiciones cuidadosamente. Los
        presentes Términos y Condiciones no afectan ninguno de los derechos del
        Usuario, sin embargo, es importante que comprenda que, al hacer uso de
        la Plataforma y de los Servicios que en ella se ofrecen, el Usuario
        entiende, reconoce y acepta estos Términos y Condiciones, por lo que
        deberán observarse en el desarrollo de cualquier actividad relacionada
        con "Prestavale". "Prestavale" se reserva el derecho de modificar, en
        cualquier momento, de forma total o parcial, los presentes Términos y
        Condiciones, por lo que, a efecto de conocer los Términos y Condiciones
        vigentes, es necesario que el Usuario los verifique y consulte de manera
        previa a su acceso a la Plataforma o a la contratación con "Prestavale".
        El uso de la Plataforma implica que el Usuario está de acuerdo con los
        Términos y Condiciones que rijan en ese momento.
      </p>
      <p>
        <strong>I. GLOSARIO.</strong>
        <br />
        <br />
        Para los efectos de estos Términos y Condiciones se entenderá por, en plural o en singular:
        <br />
        <br />
        a) Administrador de Cuenta: a cualquier persona física con plena capacidad jurídica para contratar, que administra o ejecuta determinados actos en la Plataforma, a través de la cuenta de algún Usuario, con consentimiento de este.
      </p>
      <p>
        b) "Prestavale": a CORPORATIVO 150, S.A.P.I. de C.V.
      </p>
      <p>
        c) Distribuidora: a la persona física, que está afiliada a "Prestavale" y que comercializa productos o servicios a través de la Plataforma de "Prestavale".
      </p>
      <p>
        d) Comisión por Servicio: a la tarifa o tasa que deberá pagar el acreditado al momento de contratar un préstamo con "Prestavale".
      </p>
      <p>
        e) Cuenta o Cuenta de Acceso: al perfil creado por el Usuario en la Plataforma para acceder a los Servicios.
      </p>
      <p>
        f) Derechos ARCO: a los derechos de Acceso, Rectificación, Cancelación y Oposición de los datos personales de los Usuarios.
      </p>
      <p>
        g) Fecha de Vencimiento: al día límite en que el Usuario podrá realizar el Pago Oportuno a "Prestavale" por los Servicios prestados, sin que se generen Tarifas por Retardo.
      </p>
      <p>
        h) Historial Crediticio: al registro de los créditos que el Usuario ha contratado, así como de las deudas que tenga pendientes por cubrir, y de la información respecto de puntualidad en los pagos que haya realizado.
      </p>
      <p>
        i) Banco Aliado: La persona moral o institución financiera, autorizada para organizarse y operar como cámara de compensación para pagos con tarjetas por el Banco de México.
      </p>
      <p>
        j) NIP: al Número de Identificación Personal del Usuario.
      </p>
      <p>
        k) Pago Automático: al cargo que "Prestavale" realiza directamente al método de pago que el Usuario haya registrado en la Plataforma.
      </p>
      <p>
        l) Pago Oportuno: a la amortización o liquidación que el Usuario realiza a "Prestavale" a más tardar en la Fecha de Vencimiento.
      </p>
      <p>
        m) Partes: a la referencia, de forma conjunta, de los Usuarios y "Prestavale".
      </p>
      <p>clear
        n) Plataforma: al sitio <a href="https://prestavale.mx/" target="_blank" rel="noopener noreferrer">prestavale.mx</a>
      </p>
      <p>
        o) Productos: a los bienes y servicios comercializados en las plataformas de Prestavale por sus Distribuidoras o por "Prestavale" directamente.
      </p>
      <p>
        p) Registros y Marcas: a la Plataforma, incluyendo su estructura, funcionamiento, diseño, interfaces, bases de datos, texto, contenido digital, imágenes, y todos los elementos gráficos que lo componen, etiquetas HTML (meta-tags), registros, patentes, derechos de autor, nombres comerciales, marcas, secretos industriales, mejoras industriales, y, en general, cualesquiera otros derechos de propiedad industrial e intelectual registrados a favor de "Prestavale" o de alguna de sus subsidiarias o filiales o que de alguna forma tengan relación con la Plataforma.
      </p>
      <p>
        q) Representante Autorizado: a la persona física, con plena capacidad jurídica para contratar, que se encuentra legalmente facultado, ya sea por tener la calidad de representante o por ser apoderado del Usuario, para actuar en nombre y representación de este.
      </p>
      <p>
        r) Servicios: a cualquier funcionalidad proporcionada en internet por "Prestavale" y que se pone a disposición de los Usuarios a través de la Plataforma.
      </p>
      <p>
        s) Tarifa por Retardo: a las penalizaciones dinerarias que se generan al Usuario que no realiza uno o más Pagos Oportunos.
      </p>
      <p>
        t) Transacción: al pago que "Prestavale" realice por la adquisición de uno o más Productos por cuenta del Usuario.
      </p>
      <p>
        u) Usuario: a cualquier persona, física o moral, que utiliza la Plataforma, ya sea para navegar o para hacer uso de los Servicios.
      </p>
      <p>
        <strong>
          II. INFORMACIÓN SOBRE "Prestavale".
        </strong>
      </p>
      <p>
        La Plataforma está administrada por "Prestavale", cuyo domicilio se encuentra ubicado en Av. Lázaro Cárdenas e Insurgentes Num. 970 Sur Col. Los Pinos, Culiacán, Sinaloa, C.P. 80128.
      </p>
      <p>
        En caso de tener cualquier duda, queja, sugerencia, reclamación o aclaración sobre los Servicios de "Prestavale", el Usuario podrá contactarse con nosotros a través del número "6677127532"
      </p>
      <p>
        <strong>
          III. PRIVACIDAD Y PROTECCIÓN DE DATOS.
        </strong>
      </p>
      <p>
        Agradecemos al Usuario revisar nuestro Aviso de Privacidad que se encuentra en la Plataforma, con el objeto de entender de manera integral nuestras políticas sobre protección de datos.
      </p>
      <p>
        <strong>
          IV. DE LA PLATAFORMA Y DE LOS SERVICIOS.
        </strong>
      </p>
      <p>
        "Prestavale" ofrece una plataforma digital a través de la cual otorga créditos a los Usuarios que deseen adquirir Productos a través de las Distribuidoras, pagando el monto total del Producto correspondiente y, posteriormente, cobrando dicho monto al Usuario en pagos parciales, más la Comisión Servicio correspondiente. Los Servicios de "Prestavale" implican una relación tripartita entre los Usuarios, la Plataforma y las Distribuidoras. Las Distribuidoras pondrán a disposición de los Usuarios la opción de pagar los Productos a través de la Plataforma de “Prestavale”. “Prestavale” no es un banco, ni se dedica a ofrecer servicios bancarios, sino que únicamente otorga créditos a los Usuarios registrados para que estos puedan adquirir determinados Productos de una Distribuidora.
      </p>
      <p>
        <strong>
          V. DEL REGISTRO EN LA PLATAFORMA.
        </strong>
      </p>
      <p>
        Cualquier persona podrá navegar en la Plataforma, pero solamente los Usuarios que sean titulares de una Cuenta de Acceso podrán utilizar los Servicios. Los menores de edad, o los Usuarios que hayan sido suspendidos temporalmente o inhabilitados de forma definitiva por "Prestavale", no podrán utilizar los Servicios, sin responsabilidad alguna para "Prestavale". Para que un Usuario pueda ser titular de una Cuenta de Acceso deberá registrarse y darse de alta en la Plataforma. Solo podrán registrarse los Usuarios que sean mayores de edad y que tengan plena capacidad jurídica y económica para contratar. Al registrarse en la Plataforma, el Usuario está aceptando todos los elementos y disposiciones de los presentes Términos y Condiciones. Para registrarse, es necesario que el Usuario complete el formulario de registro en todos sus campos con datos válidos e información personal exacta, precisa y verdadera. El Usuario asume el compromiso de actualizar sus datos personales conforme resulte necesario. "Prestavale" no se responsabiliza de la veracidad de los datos proporcionados por los Usuarios. Los Usuarios, al crear una Cuenta de Acceso, declaran, bajo formal protesta de decir verdad, que toda la información y los datos personales ingresados son exactos, íntegros, vigentes y auténticos.
      </p>
      <p>
        "Prestavale" se reserva el derecho de solicitar comprobantes y/o información adicional a efecto de corroborar los datos proporcionados por los Usuarios en la Plataforma, así como de suspender, temporal o definitivamente, a aquellos Usuarios cuyos datos no hayan podido ser confirmados o resulten falsos. Asimismo, "Prestavale" se reserva el derecho de rechazar una solicitud de registro o de suspender o inhabilitar, temporal o definitivamente, una Cuenta de Acceso en caso de detectar incongruencias o inconsistencias en la información provista por un Usuario.
      </p>
      <p>
        Los Usuarios podrán registrarse mediante la aplicación móvil “Distribuidoras Prestavale” disponible para su descarga en las plataformas de Google Play y App Store.
      </p>
      <p>
        Para el registro en la Plataforma, los Usuarios deberán proporcionar, entre otros datos, los siguientes: (i) nombre completo; (ii) domicilio; (iii) correo electrónico; (iv) número de teléfono celular; (v) fecha de nacimiento; (vi) sexo o género; (vii) Clave Única de Registro de Población (CURP) o clave del Registro Federal de Contribuyentes (RFC) y (viii) estado civil.
      </p>
      <p>
        Para completar el procedimiento de registro, los Usuarios proporcionarán su número de teléfono celular y recibirán un mensaje de texto (SMS), en donde se les proveerá de un NIP, con la finalidad de realizar una verificación electrónica de la identidad del Usuario registrado. Igualmente, los Usuarios deberán proporcionar una serie de caracteres que funjan como contraseña de su Cuenta de Acceso. Tanto los datos contenidos en las Cuentas de Acceso como las contraseñas solamente serán conocidos por el Usuario titular, en su caso, por sus Representantes Autorizados y/o Administradores de Cuenta, y por “"Prestavale"”.
      </p>
      <p>
        "Prestavale" se reserva el derecho de negar o rechazar las solicitudes de registro de los Usuarios que tengan un Historial Crediticio negativo, que no acrediten tener la capacidad económica suficiente para hacer frente a sus obligaciones contractuales, o bien, por cualquiera otra circunstancia por la que "Prestavale" considere inviable su solicitud de registro y/o crédito.
      </p>
      <p>
        <strong>
          VI. CONSENTIMIENTO PARA UTILIZAR FIRMAS Y COMUNICACIONES ELECTRÓNICAS.
        </strong>
      </p>
      <p>
        En la medida permitida por la ley aplicable, el Usuario acepta usar firmas y rúbricas electrónicas y recibir electrónicamente todos los registros, avisos, declaraciones, comunicaciones y otros artículos para todos los servicios proporcionados al Usuario, en virtud de la Tarjeta Digital y de estos términos.
      </p>
      <p>
        Al aceptar y estar de acuerdo con estos términos electrónicamente, el Usuario declara que: (1) el Usuario ha leído y comprende este consentimiento para usar firmas electrónicas y recibir comunicaciones electrónicamente; (2) el Usuario cumple con los requisitos mínimos de hardware y software necesarios.
      </p>
      <p>
        <strong>
          VII. HISTORIAL CREDITICIO Y VINCULACIÓN DE CUENTAS BANCARIAS.
        </strong>
      </p>
      <p>
        Al registrarse en la Plataforma, el Usuario deberá autorizar a "Prestavale" para que consulte su Historial Crediticio, a fin de verificar la identidad de dicho Usuario, su capacidad económica, así como para identificar la procedencia de sus recursos y determinar si es candidato para contratar con "Prestavale". Para realizar dicho procedimiento, "Prestavale" utiliza los servicios de Círculo de Crédito (www.circulodecredito.com.mx). Para que "Prestavale" pueda consultar el Historial Crediticio, el Usuario deberá otorgar su consentimiento, dando clic en el recuadro de aceptación de la “Autorización de Consulta de Historial Crediticio”, y deberá ratificar dicha autentificación mediante su NIP. En caso de que el Usuario sea registrado exitosamente en "Prestavale", deberá vincular su tarjeta de débito a la Plataforma, con la finalidad de registrar sus datos bancarios y, de este modo, permitir a "Prestavale" poder realizar cargos automáticos de las amortizaciones del crédito del usuario.
      </p>
      <p>
        Asimismo, el Usuario podrá establecer su tarjeta débito, o bien, podrá habilitar transferencias electrónicas de fondos para realizar los pagos de las amortizaciones referidas en la Cláusula de las Amortizaciones.
      </p>
      <p>
        Es posible que, debido a la realización de una Transacción, el nombre de "Prestavale", aparezca en los estados de cuenta bancarios de los Usuarios, por lo que el Usuario se obliga a reconocer dichos cargos, salvo que exista prueba fehaciente de que el Usuario no realizó una Transacción en la Plataforma.
      </p>
      <p>
        <strong>
          VIII. ACCESO A LA PLATAFORMA.
        </strong>
      </p>
      <p>
        Los Usuarios que hayan sido registrados exitosamente, podrán hacer uso de los Servicios accediendo a la Plataforma mediante su Cuenta de Acceso, para lo cual deberán ingresar su correo electrónico y su contraseña.
      </p>
      <p>
        La creación y utilización de la Cuenta de Acceso no generará costo alguno para el Usuario.
      </p>
      <p>
        Las Cuentas son personales, únicas e intransferibles, y está prohibido que un mismo Usuario posea más de una Cuenta de Acceso. En caso que "Prestavale" detecte distintas Cuentas que contengan datos coincidentes o relacionados, podrá cancelarlas, suspenderlas o inhabilitarlas.
      </p>
      <p>
        Los Usuarios podrán designar a uno o más Representantes Autorizados o Administradores de Cuenta para que administren la Cuenta del Usuario representado. Los Representantes Autorizados y/o los Administradores de Cuenta podrán realizar toda clase de actos en nombre y por cuenta del Usuario a quien representen, inclusive, tratándose del ejercicio de los Derechos ARCO del Usuario representado, salvo que dicho Usuario expresamente les limite o restrinja algunas facultades. Los Usuarios serán los únicos responsables de todos los actos que se realicen en la Plataforma por medio de su Cuenta de Acceso. Dichos actos se presumirán autorizados y/o ejecutados por el Usuario titular, independientemente del conocimiento que tenga de ellos, salvo prueba en contrario.
      </p>
      <p>
        El Usuario tomará las medidas de seguridad que considere necesarias para proteger adecuadamente y mantener la confidencialidad de la contraseña, o de cualquier otro medio de autenticación de su Cuenta de Acceso, así como de cualquier clase de información que pueda ser adquirida a través de dicha Cuenta. En caso de que el Usuario considere que su Cuenta de Acceso, la contraseña o los medios de autenticación de dicha Cuenta han sido revelados o han sido puestos en peligro por personas no autorizadas, o bien, que alguien ha accedido a su Cuenta sin su consentimiento, deberá notificarlo inmediatamente a "Prestavale", por sí mismo o a través de sus Administradores de Cuenta o Representantes Autorizados.
      </p>
      <p>
        "Prestavale" se reserva el derecho de impedir el uso de los Servicios de la Plataforma a la Cuenta reportada por el Usuario, en caso de que existan motivos para creer que dicha Cuenta, su contraseña o los medios de autenticación han sido puestos en peligro, o cuando detecte actividad sospechosa en dicha Cuenta.
      </p>
      <p>
        El Usuario también estará obligado a notificar de inmediato a "Prestavale" sobre cualquier aviso de terceros que el Usuario reciba y que pudiera afectar la capacidad de "Prestavale" para prestar los Servicios de manera efectiva o que pudiera incrementar la probabilidad de que se presentara una reclamación contra el Usuario o "Prestavale" en relación con los Servicios, como, por ejemplo, avisos de las autoridades fiscales u otras entidades gubernamentales, o bien, sentencias, resoluciones o cualquier otra clase de mandamientos judiciales con respecto a sanciones o errores relacionados con los Servicios.
      </p>
      <p>
        <strong>
          IX. VERIFICACIÓN DE CUENTAS DE ACCESO.
        </strong>
      </p>
      <p>
        Al crear una Cuenta de Acceso, el Usuario autoriza a "Prestavale" para obtener, verificar y registrar la información de la Cuenta, con el fin de asegurarse de que dicha Cuenta realmente pertenezca a un Usuario registrado en la Plataforma. "Prestavale" podrá solicitar el nombre, dirección, correo electrónico, número telefónico y/o cualquier otra información que permita identificar fehacientemente al Usuario que haga uso de los Servicios de la Plataforma. "Prestavale" podrá negar el acceso, suspender o cancelar, temporal o definitivamente, una Cuenta cuando existan elementos suficientes que le permitan determinar que dicha Cuenta ha sido “hackeada”, intervenida o violada, o bien, cuando descubra que la información contenida en dicha Cuenta es falsa o está alterada.
      </p>
      <p>
        <strong>
          X. DISTRIBUIDORAS Y PRODUCTOS.
        </strong>
      </p>
      <p>
        Los Usuarios registrados únicamente podrán adquirir a través de la Plataforma aquellos Productos que "Prestavale" haya decidido ofrecer, por lo que "Prestavale" no podrá prestar sus Servicios a Distribuidoras que no estén afiliadas con "Prestavale" y por ende vinculados con la Plataforma.
      </p>
      <p>
        <strong>
          XI.- DEVOLUCIONES, REEMBOLSOS Y CONTRACARGOS.
        </strong>
      </p>
      <p>
        En caso de que la Distribuidora apruebe la devolución o cancelación de un Producto o Productos, la Distribuidora notificará tal situación a "Prestavale" para que, en su caso, realice el reembolso de los montos pagados por el Usuario, sin cobrar ninguna clase de penalización o comisión. Los reembolsos que, en su caso, "Prestavale" realice en favor del Usuario estarán sujetos a la información proporcionada por la Distribuidora respecto a la devolución o cancelación de un Producto. En caso de cualquier controversia, reclamo, procedimiento o acción legal que se suscite entre un Usuario y una Distribuidora con motivo de la devolución o cancelación de un Producto, los Usuarios involucrados se obligan a sacar en paz y a salvo a "Prestavale", y se obligan a eximirla de cualquier clase de responsabilidad.
      </p>
      <p>
        <strong>
          XII. DESCRIPCIÓN DE LOS PRODUCTOS
        </strong>
      </p>
      <p>
        <strong>1. Vales Digitales</strong>
      </p>
      <p>
        <strong>a)Importe del Crédito:</strong>A partir de $1000.00 (mil pesos 00/100 M.N.) hasta $10,000.00 (diez mil pesos 00/100 M.N.).
      </p>
      <p>
        <strong>b)Comisión por apertura:</strong>0% (cero por ciento).
      </p>
      <p>
        <strong>c)Interés ordinario:</strong>Hasta el 440.30% (cuatrocientos cuarenta punto treinta por ciento) de interés ordinario.
      </p>
      <p>
        <strong>d)Plazo:</strong>Mínimo de 6 (seis) quincenas, hasta 18 (dieciocho) quincenas.
      </p>
      <p>
        <strong>e)Interés moratorio:</strong>Hasta el 20% (veinte por ciento) de interés moratorio, aplicable a partir del 5° (quinto) día de incumplimiento del pago.
      </p>
      <p>
        <strong>2. Préstamo Personal</strong>
      </p>
      <p>
        <strong>a)Importe del Crédito:</strong>A partir de $500.00 (quinientos pesos 00/100 M.N.) hasta $5,000.00 (cinco mil pesos 00/100 M.N.).
      </p>
      <p>
        <strong>b)Comisión por apertura:</strong>0% (cero por ciento).
      </p>
      <p>
        <strong>c)Interés ordinario:</strong>Hasta el 440.30% (cuatrocientos cuarenta punto treinta por ciento) de interés ordinario.
      </p>
      <p>
        <strong>d)Plazo:</strong>Mínimo de 6 (seis) quincenas, hasta 12 (doce) quincenas.
      </p>
      <p>
        <strong>e)Interés moratorio:</strong>Hasta el 20% (veinte por ciento) de interés moratorio, aplicable a partir del 5° (quinto) día de incumplimiento del pago.
      </p>
      <p>
        <strong>f)CAT:</strong>Hasta el 440.30% (cuatrocientos cuarenta punto treinta por ciento).
      </p>
      <p>
        <strong>XIII. ACTIVIDADES PROHIBIDAS.</strong>
      </p>
      <p>
        De manera enunciativa más no limitativa, queda estrictamente prohibido a los Usuarios de la Plataforma incurrir en cualesquiera de las siguientes conductas:
      </p>
      <p>
        1) Cometer cualquier clase de delito, o actividad que transgreda alguna ley, reglamento, código, disposiciones administrativas y, en general, cualquier clase de ordenamiento jurídico que rija en los Estados Unidos Mexicanos, incluidos estos Términos y Condiciones.
      </p>
      <p>
        2) Realizar cualquier actividad u operación mercantil que implique una Transacción con o involucre:
      </p>
      <p>
        a) Narcóticos, estupefacientes, esteroides, medicamentos o fármacos que requieran receta médica y, en general, cualesquiera otros productos que representen un riesgo para la seguridad del consumidor;
      </p>
      <p>
        b) Accesorios para drogas
      </p>
      <p>
        c) Bebidas alcohólicas, cigarros o cualquier producto de naturaleza análoga;
      </p>
      <p>
        d) Armas punzocortantes o de fuego, municiones, materiales explosivos o cualquier otro artículo que incite a la comisión de actos violentos o de algún delito; e) Fuegos artificiales;
      </p>
      <p>
        f) Productos robados, incluido contenido digital y virtual
      </p>
      <p>
        g) Huesos, órganos o residuos humanos;
      </p>
      <p>
        h) Flora y fauna, silvestre o doméstica;
      </p>
      <p>
        i) El fomento al odio, la violencia, la intolerancia racial u otras formas de intolerancia que sean discriminatorias o la explotación financiera de un delito;
      </p>
      <p>
        j) Pornografía o cualquier otra clase de artículos con contenido sexual; y,
      </p>
      <p>
        k) Artículos que transgredan cualquier derecho de autor, marca comercial, de publicidad o de privacidad, o cualquier otro derecho de propiedad de acuerdo con las leyes de cualquier jurisdicción.
      </p>
      <p>
        3) Dar a conocer datos personales de terceros a través de cualquier tipo medio de comunicación (incluyendo, sin limitar, correo electrónico, mensajería digital o electrónica, redes sociales y/o cualquier otra clase de medios de comunicación o plataformas análogos).
      </p>
      <p>
        4) Realizar cualquier clase de propaganda o proselitismo de orden político, religioso o de cualquier otra clase que sea ajena a la Plataforma.
      </p>
      <p>
        5) Interferir o intentar interferir con el funcionamiento adecuado de la Plataforma o los Servicios;
      </p>
      <p>
        6) Utilizar cualquier clase de software o dispositivos técnicos o electrónicos u otros procesos manuales o automatizados para “rastrear” o “hackear” cualquier página de la Plataforma;
      </p>
      <p>
        7) Extraer (harvest) o rascar (scrape) cualquier contenido de la Plataforma o de los Servicios;
      </p>
      <p>
        8) Intentar sondear, escanear o probar la vulnerabilidad de cualquier sistema o red de "Prestavale" o violar cualquier medida de seguridad o autenticación;
      </p>
      <p>
        9) Evitar, omitir, eliminar, desactivar, dañar, descifrar o evitar de cualquier forma cualquier medida tecnológica implementada por "Prestavale" o cualquiera de los proveedores de "Prestavale" o cualquier otro tercero (incluido otro Usuario) para proteger la Plataforma o los Servicios;
      </p>
      <p>
        10) Descargar cualquier clase de contenido o información de la Plataforma o los Servicios mediante el uso de cualquier motor, software, herramienta, agente, dispositivo o mecanismo, que no sean el software y/o agentes de búsqueda proporcionados por "Prestavale" u otros navegadores web de terceros generalmente disponibles;
      </p>
      <p>
        11) Interferir con, o intentar interferir con, el acceso de cualquier Usuario, host o red, o usar cualquier dispositivo, software o rutina que pretenda dañar, interceptar subrepticiamente o expropiar cualquier sistema, datos o comunicación, incluyendo, entre otros, a través de enviar virus, sobrecargando, inundando, enviando spam o bombardeando por correo la Plataforma o los Servicios;
      </p>
      <p>
        12) Recopilar, haciendo uso de la Plataforma o los Servicios cualquier clase de información personal de otros Usuarios sin su expresa autorización;
      </p>
      <p>
        13) Suplantar o falsear la relación del Usuario con cualquier persona o entidad;
      </p>
      <p>
        14) Participar en prácticas o actividades fraudulentas, engañosas o ilegales, o utilizar los Servicios para apoyar directa o indirectamente tales prácticas o actividades;
      </p>
      <p>
        15) Alentar, asistir o permitir que cualquier otra persona lleve a cabo alguno o algunos de los actos anteriores.
      </p>
      <p>
        En caso de que "Prestavale" advierta que algún Usuario haya incurrido en cualquiera de las actividades anteriormente señaladas, podrá cancelar, suspender o inhabilitar la Cuenta de dicho Usuario de forma definitiva, sin que medie previo aviso, y sin perjuicio de las responsabilidades legales que, en su caso, correspondan.
      </p>
      <p>
        <strong>XIV. OBLIGACIONES DE LOS USUARIOS.</strong>
      </p>
      <p>
        Además de las obligaciones generales establecidas en estos Términos y Condiciones, los Usuarios aceptan asumir las obligaciones siguientes:
      </p>
      <p>
        1) No utilizar la Plataforma para cometer hechos ilícitos o conductas ilegales;
      </p>
      <p>
        2) A realizar los Pagos Oportunos, Comisiones por Servicio y, en su caso, las Tarifas por Retardo que correspondan, con recursos procedencia lícita;
      </p>
      <p>
        3) Mantener fondos suficientes en sus cuentas bancarias para hacer frente a las obligaciones que contraiga con "Prestavale";
      </p>
      <p>
        4) Compartir y/o comunicar únicamente información verídica, válida y que legalmente esté en posibilidades de transmitir, es decir, que no tenga alguna restricción contractual o por ministerio de ley;
      </p>
      <p>
        5) Abstenerse de publicar o compartir información distinta a la requerida por "Prestavale";
      </p>
      <p>
        6) Abstenerse de revelar cualquier clase de información personal de terceros sin consentimiento previo y por escrito de la persona correspondiente;
      </p>
      <p>
        7) Abstenerse de sustraer, anunciar, publicar o comerciar con cualquier tipo de información personal o comercial de otros Usuarios;
      </p>
      <p>
        8) No manipular la Plataforma, los Servicios, los sistemas informáticos o técnicos de "Prestavale";
      </p>
      <p>
        9) Mantener, en todo momento, la confidencialidad de su contraseña, NIP o cualquier otro medio electrónico de verificación o autentificación;
      </p>
      <p>
        10) No ceder, total o parcialmente, los derechos y obligaciones contraídas con motivo de la aceptación de estos Términos y Condiciones, sin el consentimiento previo de "Prestavale".
      </p>
      <p>
        <strong>
          XV. MENSAJES ELECTRÓNICOS.
        </strong>
      </p>
      <p>
        El Usuario, al proporcionar sus datos para la creación de una Cuenta de Acceso, acepta que "Prestavale" podrá enviarle mensajes de texto o correos electrónicos sobre la actividad de dicha Cuenta, así como para informarle sobre las actualizaciones de los Servicios, entre otros.
      </p>
      <p>
        Asimismo, el Usuario acepta que "Prestavale" podrá enviarle mensajes de texto SMS o a través de cualquier aplicación de mensajería instantánea (i.e.WhatsApp, Telegram, entre otras) o por correo electrónico sobre cobranza y promociones. El Usuario podrá cancelar su suscripción de recibir mensajes electrónicos enviando un correo electrónico incluyendo su número de teléfono a hola@prestavale.mx, siempre y cuando, el Usuario no presente ningún adeudo con "Prestavale".
      </p>
      <p>
        <strong>
          XVI. ENLACES EXTERNOS.
        </strong>
      </p>
      <p>
        A fin de que el Usuario tenga un mayor conocimiento de los presentes Términos y Condiciones, "Prestavale" puede poner a su disposición enlaces que lo redireccionará a otros sitios o páginas web distintas de la Plataforma. Dichos enlaces externos únicamente se proporcionan con fines informativos sobre temas de relevancia para que el Usuario comprenda de una mejor manera el funcionamiento de la Plataforma y de los Servicios. “Prestavale” no tiene ningún control sobre el contenido o funcionamiento de dichas interfaces y, por tal motivo, no garantiza la integridad, seguridad o confiabilidad de los referidos sitios web, por lo que el Usuario, al acceder a ellos, lo hace bajo su propio riesgo y responsabilidad. "Prestavale" no se hace responsable por los daños, perjuicios, errores, virus o cualquier tipo de daño o afectación que pueda sufrir el ordenador o dispositivo electrónico o digital con el que el Usuario haya accedido a dichos enlaces o sitios, así como tampoco se responsabiliza del robo o pérdida de información que sufra o pueda sufrir el Usuario al acceder a tales plataformas.
      </p>
      <p>
        <strong>
          XVII. PROPIEDAD INTELECTUAL.
        </strong>
      </p>
      <p>
        Los Registros y Marcas, es decir, el contenido de la Plataforma, incluyendo su estructura, diseño, interfaces, bases de datos, texto, contenido digital, imágenes, videos, música, y todos los elementos gráficos que lo componen, etiquetas HTML (meta-tags), registros, patentes, derechos de autor, nombres comerciales, marcas, secretos industriales, mejoras industriales, y, en general, cualesquiera otros derechos de propiedad industrial e intelectual registrados a su favor o que de alguna forma tengan relación con la Plataforma, son propiedad exclusiva de "Prestavale", por lo que los Usuarios se obligan a no realizar o llevar a cabo un uso indebido o no autorizado por parte de "Prestavale". Este contenido está protegido por las disposiciones de la Ley de Propiedad Industrial, y por toda normativa texto nacional o internacional aplicable a la materia de propiedad intelectual.
      </p>
      <p>
        Cualquier uso no autorizado realizado directamente por los Usuarios, o a través de algún tercero, respecto a cualesquiera de los Registros y Marcas de "Prestavale", o acto de competencia desleal, generará la obligación de los Usuarios de pagar a "Prestavale" los daños y perjuicios que le ocasione, sin perjuicio de la infracción en la que incurra en términos de la Ley de la Propiedad Industrial y/o delitos en términos de la legislación penal que resulte aplicable.
      </p>
      <p>
        Cualquier reproducción, distribución o uso de todo o parte del contenido de la Plataforma en cualquier forma, sin la autorización previa y por escrito de "Prestavale", constituirá un incumplimiento a los presentes Términos y Condiciones, y además de las consecuencias y sanciones previstas en el presente documento, será responsable de los daños y perjuicios que dicho incumplimiento haya podido generar a "Prestavale".
      </p>
      <p>
        Los Usuarios, en relación con el uso de la Plataforma, se abstendrán de realizar las siguientes acciones directamente o través de terceros:
      </p>
      <p>
        1) Extraer, utilizar o poner a disposición del público, elementos, o parte o la totalidad de la Plataforma y otras bases de datos visibles en ella, con fines comerciales o de otra índole.
      </p>
      <p>
        2) Extraer o usar toda o parte de la información visible en la Plataforma, cuando dicha operación exceda el uso normal y privado de los servicios de "Prestavale".
      </p>
      <p>
        3) Explotar, comercializar o distribuir cualquier elemento de la Plataforma y cualquier otra base de datos.
      </p>
      <p>
        4) Utilizar el software o procesos manuales para copiar la página web de la Plataforma o para registrar o recopilar información de estas páginas sin el consentimiento expreso previo y por escrito de "Prestavale".
      </p>
      <p>
        5) Usar dispositivos o software para crear bugs o errores, o interrumpir o intentar interrumpir el funcionamiento de la Plataforma
      </p>
      <p>
        <strong>
          XVIII. RESPONSABILIDAD.
        </strong>
      </p>
      <p>
        "Prestavale" no se responsabiliza por cualquier daño, perjuicio, pérdida o robo de datos o información que se suscite por fallas en el sistema, en el servidor o en internet, o en los enlaces externos a los que acceda el Usuario. "Prestavale" tampoco se hace responsable por cualquier virus que pudiera infectar el equipo del Usuario como consecuencia del acceso o uso de la Plataforma o de las plataformas de los Comercios Afiliados o de los enlaces externos que "Prestavale" ponga a disposición de los Usuarios. Los Usuarios no podrán atribuirle ningún tipo de responsabilidad a "Prestavale" ni exigir el pago por daños y perjuicios resultantes de dificultades técnicas o fallas en los sistemas o en internet. "Prestavale" no garantiza el acceso y uso continuado o ininterrumpido de la Plataforma. El sistema puede, eventualmente, no estar disponible debido a dificultades técnicas o fallas en internet, o por cualquier otra circunstancia ajena a "Prestavale", en tales casos, se procurará restablecerlo con la mayor celeridad posible, sin que por ello pueda imputársele algún tipo de responsabilidad.
      </p>
      <p>
        "Prestavale" no es responsable de la veracidad de los datos o información asentada por los Usuarios al momento de crear una Cuenta de Acceso. "Prestavale" tampoco se hace responsable por la actividad que los Usuarios realicen en la Plataforma, por lo que cada uno de los Usuarios entiende, reconoce y acepta que es el único responsable de las actividades que realice en la Plataforma a través de su Cuenta, salvo prueba en contrario.
      </p>
      <p>
        <strong>
          XIX. CONDICIONES ADICIONALES DE USO.
        </strong>
      </p>
      <p>
        "Prestavale" podrá establecer Condiciones Adicionales de Uso a los presentes Términos y Condiciones, las cuales formarán parte integrante de estos. Las Condiciones Adicionales de Uso serán aplicables a determinados Servicios, tales como promociones particulares u otros beneficios o funcionalidades que "Prestavale" ponga a disposición de los Usuarios para una finalidad en específico. En caso de conflicto entre los presentes Términos y Condiciones las Condiciones Adicionales de Uso, prevalecerán estas últimas sobre los primeros.
      </p>
      <p>
        <strong>
          XX. TERMINACIÓN DE LOS SERVICIOS.
        </strong>
      </p>
      <p>
        El uso de los Servicios de la Plataforma y las disposiciones de los presentes Términos y Condiciones continuarán vigentes hasta que cualquiera de las Partes los dé por terminados. Los Usuarios podrán dar por terminados los presentes Términos y Condiciones, en cualquier momento, dando de baja o cancelando su Cuenta de Acceso. Por su parte, "Prestavale" podrá dar por terminados estos Términos y Condiciones en cualquier momento y por cualquier circunstancia.
      </p>
      <p>
        Además del derecho de terminación anterior, "Prestavale" podrá cancelar o dar de baja una Cuenta de Acceso; o suspender o restringir el acceso del Usuario a la Plataforma o a cualquier Servicio; o dar por terminados inmediatamente los presentes Términos y Condiciones, sin necesidad de que medie aviso previo y por escrito, en cualquiera de los casos siguientes:
      </p>
      <p>
        ● Incumplimiento o violación, total o parcial, de los presentes Términos y Condiciones por parte del Usuario o de las obligaciones específicas establecidas en la Cláusula de las Obligaciones del Usuario;
      </p>
      <p>
        ● Conductas ilícitas o indebidas que el Usuario realice en la Plataforma, y que puedan provocar, directa o indirectamente, algún tipo de responsabilidad jurídica para "Prestavale";
      </p>
      <p>
        ● Que el Usuario falsifique o altere cualquier dato o información contenido en su Cuenta o en la Cuenta de otros Usuarios, o que haya participado en prácticas fraudulentas o engañosas o actividades ilícitas;
      </p>
      <p>
        ● Cuando el Usuario realice alguna de las conductas prohibidas de las enunciadas en la Cláusula de las Actividades Prohibidas de estos Términos y Condiciones.
      </p>
      <p>
        Tras la terminación de cualquiera de los Servicios y/o la terminación de los Términos y Condiciones, el derecho del Usuario a acceder y utilizar dichos Servicios se cancelará automáticamente. Una vez cancelada una Cuenta, "Prestavale" podrá eliminar cualquier tipo de contenido, información o registro de actividad referente a dicha Cuenta.
      </p>
      <p>
        Si al momento en que "Prestavale" suspenda, cancele o restrinja, total o parcialmente, una Cuenta, existieren obligaciones pendientes por cumplir, dicha suspensión, cancelación o restricción no implicará la eliminación o cancelación de tales obligaciones, sino que estas subsistirán y seguirán siendo exigibles hasta su total cumplimiento.
      </p>
      <p>
        Debido a que la contratación "Prestavale" implica una relación con los Comercios Afiliados, puede suceder que alguno o algunos de dichos Comercios Afiliados suspendan o inhabiliten, temporal o definitivamente la cuenta de acceso que el Usuario haya creado en sus plataformas, o bien, que los Comercios Afiliados decidan dejar de prestar sus servicios en favor del Usuario cuando consideren que éste ha infringido las leyes aplicables o los términos y condiciones de uso de sus plataformas respectivas, por lo que "Prestavale" no se hace responsable por tal situación, quedando subsistentes las obligaciones que el Usuario tenga pendientes por cubrir en favor de "Prestavale".
      </p>
      <p>
        <strong>
          XXI. NO DISCRIMINACIÓN.
        </strong>
      </p>
      <p>
        "Prestavale" no discrimina a ningún Usuario por motivos de raza, religión, género, orientación sexual, nacionalidad, condición física o socioeconómica, ni por ninguna otra circunstancia o particularidad.
      </p>
      <p>
        <strong>
          XXII. ESTIPULACIONES DIVISIBLES.
        </strong>
      </p>
      <p>
        En caso de que cualquiera de las disposiciones de estos Términos y Condiciones sea nula o inaplicable por o como resultado de la determinación judicial de cualquier autoridad o tribunal, las Partes acuerdan que dicha determinación no implica la nulidad o inaplicabilidad del resto de las Cláusulas. Sin perjuicio de los derechos específicamente otorgados en cualquier otra parte de estos Términos y Condiciones, las Partes acuerdan reemplazar dicha disposición nula o inaplicable por una disposición válida y aplicable que permita, en la medida de lo posible, cumplir con los propósitos económicos y de negocios de las disposiciones que hayan sido declaradas nulas o inaplicables.
      </p>
      <p>
        <strong>
          XXIII. MODIFICACIONES.
        </strong>
      </p>
      <p>
        "Prestavale" podrá modificar en cualquier momento los presentes Términos y Condiciones. En caso de que "Prestavale" realice cualquier modificación a estos Términos y Condiciones, informará al Usuario mediante la publicación de dichas modificaciones en la Plataforma. Es importante que el Usuario revise los Términos y Condiciones cada vez que estos sean modificados por "Prestavale", a fin de estar en aptitud de oponerse a tales modificaciones, de lo contrario, "Prestavale" considerará que el Usuario ha aceptado dichas modificaciones y, consecuentemente, estará obligado a cumplir con ellas. En caso de que el Usuario no acepte quedar obligado por las modificaciones realizadas a los Términos y Condiciones, no podrá continuar utilizando la Plataforma o los Servicios ofrecidos por esta.
      </p>
      <p>
        <strong>
          XXIV. JURISDICCIÓN.
        </strong>
      </p>
      <p>
        Los presentes Términos y Condiciones se rigen por la legislación mexicana y, para cualquier disputa o controversia que surja como consecuencia de la interpretación, alcances, ejecución y/o cumplimiento de estos, el Usuario se somete expresamente a la jurisdicción y competencia de los Tribunales de la Ciudad de México, renunciando expresamente a cualquier otro fuero o competencia que, por razón de su domicilio, presente o futuro, o por cualquier otra causa pudiera corresponderle.
      </p>
      <p>
        <strong>
          XXV. CONSENTIMIENTO POR MEDIOS ELECTRÓNICOS.
        </strong>
      </p>
      <p>
        El Usuario acepta expresamente manifestar su conformidad y consentimiento con los presentes Términos y Condiciones a través de medios electrónicos, en específico, mediante un Número de Identificación Personal (NIP), el cual tendrá la misma validez y eficacia que la firma autógrafa, de conformidad con lo dispuesto por el artículo 80 del Código de Comercio, en relación con el artículo 1803 del Código Civil Federal.
      </p>
      <p>
        Asimismo, el Usuario entiende, reconoce y acepta que, para poder tener acceso a los Servicios de la Plataforma, "Prestavale" podrá solicitarle dicho NIP, a fin de verificar la identidad del Usuario.
      </p>
      <p>
        Al momento de formar parte de la comunidad de "Prestavale", en cualquier calidad, manifiesta haber leído, comprendido y aceptado los presentes Términos y Condiciones, sin que medie algún vicio de la voluntad.
      </p>
      <p>
        Fecha de última actualización 26 de agosto de 2025.
      </p>
      <p>
        © {new Date().getFullYear()} Prestavale. Todos los derechos reservados Condiciones de uso, avisos fiscales y de privacidad
      </p>
    </Content>
  );
};

export default TerminosYCondiciones;
